/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AddDisciplineGroupDTO,
    AddDisciplineGroupDTOFromJSON,
    AddDisciplineGroupDTOToJSON,
    DisciplineGroupDTO,
    DisciplineGroupDTOFromJSON,
    DisciplineGroupDTOToJSON,
    DisciplineGroupGetAllDTOPagedResponse,
    DisciplineGroupGetAllDTOPagedResponseFromJSON,
    DisciplineGroupGetAllDTOPagedResponseToJSON,
    EditDisciplineGroupDTO,
    EditDisciplineGroupDTOFromJSON,
    EditDisciplineGroupDTOToJSON,
    SemesterTypeEnum,
    SemesterTypeEnumFromJSON,
    SemesterTypeEnumToJSON,
    StudyYearEnum,
    StudyYearEnumFromJSON,
    StudyYearEnumToJSON,
    SubjectRequestType,
    SubjectRequestTypeFromJSON,
    SubjectRequestTypeToJSON,
    SubjectsForGroupDTO,
    SubjectsForGroupDTOFromJSON,
    SubjectsForGroupDTOToJSON,
} from '../models';

export interface ApiDisciplineGroupAddDisciplineGroupPostRequest {
    addDisciplineGroupDTO?: AddDisciplineGroupDTO;
}

export interface ApiDisciplineGroupAssignDisciplineToGroupIdPutRequest {
    id: string;
    requestBody?: Array<string>;
}

export interface ApiDisciplineGroupDeleteIdDeleteRequest {
    id: string;
}

export interface ApiDisciplineGroupGetAllDisciplineGroupsGetRequest {
    namePattern?: string;
    semester?: SemesterTypeEnum;
    studyYear?: StudyYearEnum;
    studyPlanId?: string;
    page?: number;
    pageSize?: number;
}

export interface ApiDisciplineGroupGetAllSubjectsForGroupsGetRequest {
    semester?: SemesterTypeEnum;
    studyYear?: StudyYearEnum;
    groupId?: string;
    planId?: string;
    subGroupId?: string;
    subjectRequestType?: SubjectRequestType;
}

export interface ApiDisciplineGroupGetDisciplineGroupByIdIdGetRequest {
    id: string;
}

export interface ApiDisciplineGroupUpdateDisciplineGroupIdPutRequest {
    id: string;
    editDisciplineGroupDTO?: EditDisciplineGroupDTO;
}

/**
 * 
 */
export class DisciplineGroupApi extends runtime.BaseAPI {

    /**
     */
    async apiDisciplineGroupAddDisciplineGroupPostRaw(requestParameters: ApiDisciplineGroupAddDisciplineGroupPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/DisciplineGroup/AddDisciplineGroup`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddDisciplineGroupDTOToJSON(requestParameters.addDisciplineGroupDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDisciplineGroupAddDisciplineGroupPost(requestParameters: ApiDisciplineGroupAddDisciplineGroupPostRequest = {}, initOverrides?: RequestInit): Promise<void> {
        await this.apiDisciplineGroupAddDisciplineGroupPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiDisciplineGroupAssignDisciplineToGroupIdPutRaw(requestParameters: ApiDisciplineGroupAssignDisciplineToGroupIdPutRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiDisciplineGroupAssignDisciplineToGroupIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/DisciplineGroup/AssignDisciplineToGroup/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDisciplineGroupAssignDisciplineToGroupIdPut(requestParameters: ApiDisciplineGroupAssignDisciplineToGroupIdPutRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiDisciplineGroupAssignDisciplineToGroupIdPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiDisciplineGroupDeleteIdDeleteRaw(requestParameters: ApiDisciplineGroupDeleteIdDeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiDisciplineGroupDeleteIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/DisciplineGroup/Delete/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDisciplineGroupDeleteIdDelete(requestParameters: ApiDisciplineGroupDeleteIdDeleteRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiDisciplineGroupDeleteIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiDisciplineGroupGetAllDisciplineGroupsGetRaw(requestParameters: ApiDisciplineGroupGetAllDisciplineGroupsGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<DisciplineGroupGetAllDTOPagedResponse>> {
        const queryParameters: any = {};

        if (requestParameters.namePattern !== undefined) {
            queryParameters['NamePattern'] = requestParameters.namePattern;
        }

        if (requestParameters.semester !== undefined) {
            queryParameters['Semester'] = requestParameters.semester;
        }

        if (requestParameters.studyYear !== undefined) {
            queryParameters['StudyYear'] = requestParameters.studyYear;
        }

        if (requestParameters.studyPlanId !== undefined) {
            queryParameters['StudyPlanId'] = requestParameters.studyPlanId;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['Page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['PageSize'] = requestParameters.pageSize;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/DisciplineGroup/GetAllDisciplineGroups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DisciplineGroupGetAllDTOPagedResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiDisciplineGroupGetAllDisciplineGroupsGet(requestParameters: ApiDisciplineGroupGetAllDisciplineGroupsGetRequest = {}, initOverrides?: RequestInit): Promise<DisciplineGroupGetAllDTOPagedResponse> {
        const response = await this.apiDisciplineGroupGetAllDisciplineGroupsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiDisciplineGroupGetAllSubjectsForGroupsGetRaw(requestParameters: ApiDisciplineGroupGetAllSubjectsForGroupsGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<SubjectsForGroupDTO>>> {
        const queryParameters: any = {};

        if (requestParameters.semester !== undefined) {
            queryParameters['Semester'] = requestParameters.semester;
        }

        if (requestParameters.studyYear !== undefined) {
            queryParameters['StudyYear'] = requestParameters.studyYear;
        }

        if (requestParameters.groupId !== undefined) {
            queryParameters['GroupId'] = requestParameters.groupId;
        }

        if (requestParameters.planId !== undefined) {
            queryParameters['PlanId'] = requestParameters.planId;
        }

        if (requestParameters.subGroupId !== undefined) {
            queryParameters['SubGroupId'] = requestParameters.subGroupId;
        }

        if (requestParameters.subjectRequestType !== undefined) {
            queryParameters['SubjectRequestType'] = requestParameters.subjectRequestType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/DisciplineGroup/GetAllSubjectsForGroups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubjectsForGroupDTOFromJSON));
    }

    /**
     */
    async apiDisciplineGroupGetAllSubjectsForGroupsGet(requestParameters: ApiDisciplineGroupGetAllSubjectsForGroupsGetRequest = {}, initOverrides?: RequestInit): Promise<Array<SubjectsForGroupDTO>> {
        const response = await this.apiDisciplineGroupGetAllSubjectsForGroupsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiDisciplineGroupGetDisciplineGroupByIdIdGetRaw(requestParameters: ApiDisciplineGroupGetDisciplineGroupByIdIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<DisciplineGroupDTO>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiDisciplineGroupGetDisciplineGroupByIdIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/DisciplineGroup/GetDisciplineGroupById/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DisciplineGroupDTOFromJSON(jsonValue));
    }

    /**
     */
    async apiDisciplineGroupGetDisciplineGroupByIdIdGet(requestParameters: ApiDisciplineGroupGetDisciplineGroupByIdIdGetRequest, initOverrides?: RequestInit): Promise<DisciplineGroupDTO> {
        const response = await this.apiDisciplineGroupGetDisciplineGroupByIdIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiDisciplineGroupUpdateDisciplineGroupIdPutRaw(requestParameters: ApiDisciplineGroupUpdateDisciplineGroupIdPutRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiDisciplineGroupUpdateDisciplineGroupIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/DisciplineGroup/UpdateDisciplineGroup/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EditDisciplineGroupDTOToJSON(requestParameters.editDisciplineGroupDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDisciplineGroupUpdateDisciplineGroupIdPut(requestParameters: ApiDisciplineGroupUpdateDisciplineGroupIdPutRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiDisciplineGroupUpdateDisciplineGroupIdPutRaw(requestParameters, initOverrides);
    }

}
